import React, { useEffect, useContext } from "react";
import { ProfileContext } from "../context/ProfileContext";
import { SchedJobContext } from "../context/JobContextScheduler";
import { db } from "../firebase";
import { collection, getDocs, query, where } from "firebase/firestore";
import { RouteComponentProps, useHistory } from "react-router-dom";
import { HEADERTEXT_TYPES, WORKFLOW_WERKER_TYPES } from "../functions/postActionTypes";
import {
  IonContent,
  IonPage,
  IonGrid,
  IonButton,
  IonLabel,
  IonItem,
  IonList,
  IonCheckbox,
  IonAvatar,
  IonSearchbar,
  IonFooter,
  IonToolbar,
  useIonAlert,
  IonBadge,
  IonAccordionGroup,
  IonAccordion,
  IonText,
  useIonToast,
} from "@ionic/react";
import "../theme/AppStyles.css";
import { WerkerSchedulerHeader } from "../components/WerkHeader";
import { fx_FB_WerkerInvitePending, WerkerChange } from "../functions/fx_FB_WerkerInvitePending";
import { CrewContext } from "../context/CrewContext";
import { useWerkerSelection, AssociatesData } from "../hooks/scheduler/useWerkerSelection";
import { formatForJobInvitation } from "../utils/userInfoFormatting";

interface PublishJobProps extends RouteComponentProps<{ id: string }> {}

interface SelectWerkersDesktopMode {
  isDesktopMode: boolean;
  jobId: string;
  onComplete: (result?: { nextView?: "details"; jobId?: string }) => void;
}

interface SelectWerkersProps extends Partial<PublishJobProps> {
  desktopMode?: SelectWerkersDesktopMode;
}

const SelectWerkers: React.FC<SelectWerkersProps> = ({ match, desktopMode }) => {
  const history = useHistory<any>();
  const { profile, myAssociates } = useContext(ProfileContext);
  const { schedJob } = useContext(SchedJobContext);
  const { crews, crewsLoading } = useContext(CrewContext);
  const [_presentAlert] = useIonAlert();
  const [presentToast] = useIonToast();
  const routeJobId = desktopMode?.jobId ?? match?.params?.id ?? "";
  const isDesktopMode = desktopMode?.isDesktopMode === true;

  // Use werker selection hook for all selection logic
  const {
    searchText,
    setSearchText,
    crewAccordionValue,
    setCrewAccordionValue,
    initialAssociatesCrew,
    setInitialAssociatesCrew,
    associatesCrew,
    setAssociatesCrew,
    contentRef,
    onContentScroll,
    filteredSorted,
    allFilteredSelected,
    someFilteredSelected,
    visibleUidsCount,
    visibleSelectedCount,
    handleSelectAllClick,
    handleCrewList,
    applyCrewToSelection,
    getInitials,
  } = useWerkerSelection();

  // Fetch & merge associates with jobDocs
  useEffect(() => {
    const fetchAssociates = async () => {
      try {
        const userArray: AssociatesData[] = [];
        // console.log("FETCHASSOCIATES routeId", routeJobId);

        const jobsQ = query(
          collection(db, "jobsDocs"),
          where("jobInfo.core.uniqueJobId", "==", routeJobId),
          where("jobInfo.status.jobStatusWerker", "in", [
            WORKFLOW_WERKER_TYPES.Invited,
            WORKFLOW_WERKER_TYPES.Scheduled,
            WORKFLOW_WERKER_TYPES.Past,
            "",
          ])
        );
        const querySnapshot = await getDocs(jobsQ);

        const jobDocsArray: {
          JobDocId: string;
          WerkerUid: string;
          WerkerInviteStatus: string;
        }[] = [];

        querySnapshot.forEach((docSnap: any) => {
          const jobDocDetail = docSnap.data();
          if (jobDocDetail.docStamp.userInfoTo.uid === profile.UserId) {
            if (jobDocDetail.jobInfo.status.jobStatusWerker !== "") {
              userArray.push(
                formatForJobInvitation(
                  {
                    WerkerUid: profile.UserId,
                    WerkerFirstName: profile.FirstName,
                    WerkerLastName: profile.LastName,
                    WerkerCompany: profile.Company,
                    WerkerProfilePicURL: profile.ProfilePicURL,
                    WerkerBio: profile.UserBio,
                  },
                  true,
                  routeJobId
                )
              );
            }
          } else {
            jobDocsArray.push({
              JobDocId: docSnap.id,
              WerkerUid: jobDocDetail.docStamp.userInfoTo.uid,
              WerkerInviteStatus: jobDocDetail.jobInfo.status.jobStatusWerker,
            });
          }
        });

        myAssociates.forEach((myAss: any) => {
          const existing = jobDocsArray.find((x) => x.WerkerUid === myAss.WerkerUid);
          const invited =
            existing?.WerkerInviteStatus === WORKFLOW_WERKER_TYPES.Invited ||
            existing?.WerkerInviteStatus === WORKFLOW_WERKER_TYPES.Scheduled ||
            existing?.WerkerInviteStatus === WORKFLOW_WERKER_TYPES.Past;

          // Skip empties to avoid phantom rows
          if (myAss.WerkerUid) {
            userArray.push(
              formatForJobInvitation(
                {
                  WerkerUid: myAss.WerkerUid,
                  WerkerFirstName: myAss.WerkerFirstName,
                  WerkerLastName: myAss.WerkerLastName,
                  WerkerCompany: myAss.WerkerCompany,
                  WerkerProfilePicURL: myAss.WerkerProfilePicURL,
                  WerkerBio: myAss.WerkerBio,
                },
                Boolean(invited),
                existing?.JobDocId || ""
              )
            );
          }
        });

        setAssociatesCrew(userArray);
        setInitialAssociatesCrew(userArray);
      } catch (err) {
        // console.log(err);
      }
    };
    fetchAssociates();
  }, [profile, myAssociates, routeJobId, setAssociatesCrew, setInitialAssociatesCrew]);

  // Submit //////////////////////////////
  const handleSubmit = async () => {
    // console.log("SUBMIT CLICKED", {
    //   jobId: routeJobId,
    //   subscriptionType: profile?.SubscriptionType,
    //   invitedCount: associatesCrew.filter((a) => a.isInvited).length,
    // });
    /////

    // console.log("CHANGES", { changed });

    if (profile.SubscriptionType !== "Scheduler") {
      history.push({
        pathname: `/Paywall`,
        state: { cameFrom: "SelectWerkers" },
      });
      return;
    }

    if (routeJobId === "announcement") {
      // console.log("Announcement");
      var announcementAssociates = [];
      announcementAssociates = associatesCrew.filter((associate: { isInvited: any }) => associate.isInvited);

      // console.log(announcementAssociates);

      history.push({
        pathname: `/Announcement`,
        state: {
          cameFrom: "AnnouncementSelectWerkers",
          selectedAssociates: announcementAssociates,
        },
      });
    } else {
      const jobInfo = schedJob.find((x: { JobDocId: string }) => x.JobDocId === routeJobId);
      // console.log("JOB INFO", {
      //   routeId: routeJobId,
      //   JobDocId: jobInfo?.JobDocId,
      //   uniqueJobId: jobInfo?.jobInfo?.core?.uniqueJobId, // adjust if different
      //   uniqueJobIdAlt: jobInfo?.UniqueJobId, // adjust if different
      // });

      if (!jobInfo) {
        if (desktopMode?.onComplete) {
          desktopMode.onComplete({ nextView: "details", jobId: routeJobId });
        } else {
          history.goBack();
        }
        return;
      }

      try {
        // Calculate changed werkers
        const changed = associatesCrew.filter((u) => {
          const init = initialAssociatesCrew.find((x) => x.WerkerUid === u.WerkerUid);
          return init && init.isInvited !== u.isInvited;
        });

        if (changed.length === 0) {
          // No changes, just navigate back
          if (desktopMode?.onComplete) {
            desktopMode.onComplete({ nextView: "details", jobId: routeJobId });
          } else if (history.location.state === undefined) {
            history.goBack();
          } else {
            history.replace(`/SchedShiftDetail/${routeJobId}`);
          }
          return;
        }

        // Map to WerkerChange format
        const werkerChanges: WerkerChange[] = changed.map((werker) => ({
          werkerUid: werker.WerkerUid,
          isInvited: werker.isInvited,
          existingDocId: werker.DocId || null,
          werkerFirstName: werker.WerkerFirstName,
          werkerLastName: werker.WerkerLastName,
          werkerProfilePicURL: werker.WerkerProfilePicURL,
          werkerCompany: werker.WerkerCompany,
        }));

        // Trigger async werker invite processing
        await fx_FB_WerkerInvitePending(
          profile.UserId,
          [routeJobId], // Single job
          werkerChanges,
          {
            company: jobInfo.Company,
            location: jobInfo.Location,
            locationCoordinates: jobInfo.LocationCoordinates,
            pay: jobInfo.Pay,
            shiftIdentifier: jobInfo.ShiftIdentifier,
            shiftNotes: jobInfo.ShiftNotes,
            dateTimeStart: jobInfo.StartDateTimeRaw,
            dateTimeFinish: jobInfo.FinishDateTimeRaw,
            numJobSlots: jobInfo.numJobSlots || 1,
            jobStatusSched: jobInfo.JobStatusSched,
          },
          {
            firstName: profile.FirstName,
            lastName: profile.LastName,
            userId: profile.UserId,
            profilePicURL: profile.ProfilePicURL,
          }
        );

        // Show immediate feedback toast
        const invitedCount = changed.filter((w) => w.isInvited).length;
        await presentToast({
          message: `Inviting ${invitedCount} werker${invitedCount === 1 ? "" : "s"}...`,
          duration: 2000,
          position: "top",
          color: "medium",
        });
      } catch (e) {
        console.error("Error triggering werker invite:", e);
        presentToast({
          message: "Failed to trigger invite. Please try again.",
          duration: 2500,
          position: "top",
          color: "danger",
        });
        return;
      }

      if (history.location.state === undefined) {
        if (desktopMode?.onComplete) {
          desktopMode.onComplete({ nextView: "details", jobId: routeJobId });
        } else {
          history.goBack();
        }
      } else {
        if (desktopMode?.onComplete) {
          desktopMode.onComplete({ nextView: "details", jobId: routeJobId });
        } else {
          history.replace(`/SchedShiftDetail/${routeJobId}`);
        }
      }
    }
  };

  // Render
  if (isDesktopMode) {
    return (
      <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
        <div
          style={{
            backgroundColor: "var(--ion-background-color)",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            minHeight: 56,
            padding: "0 12px",
            boxSizing: "border-box",
            borderBottom: "1px solid var(--ion-color-light-shade)",
            flexShrink: 0,
          }}
        >
          <IonButton
            onClick={() => desktopMode?.onComplete({ nextView: "details", jobId: routeJobId })}
            fill="clear"
            style={{ margin: 0 }}
          >
            Back
          </IonButton>
          <div style={{ flex: 1, textAlign: "center" }}>
            <strong><h2 style={{ margin: 0, lineHeight: "24px" }}>{HEADERTEXT_TYPES.ChooseWerkers}</h2></strong>
          </div>
          <IonButton
            onClick={handleSubmit}
            fill="clear"
            color="dark"
            style={{ margin: 0 }}
          >
            <strong>Submit</strong>
          </IonButton>
          <IonButton
            onClick={() => desktopMode?.onComplete({ nextView: "details", jobId: routeJobId })}
            fill="clear"
            color="medium"
            style={{ margin: 0 }}
          >
            Invite Later
          </IonButton>
        </div>

        <IonContent
          ref={contentRef}
          scrollEvents={true}
          onIonScroll={onContentScroll}
          style={{ flex: 1 }}
        >
          <IonSearchbar
            placeholder="Filter by #Tag, name, company, etc..."
            value={searchText}
            onIonChange={(e: any) => setSearchText(e.detail.value!)}
          />
          <IonAccordionGroup
            value={crewAccordionValue}
            onIonChange={(e) => setCrewAccordionValue((e.detail.value as string) || undefined)}
          >
            <IonAccordion value="crews">
              <IonItem slot="header" lines="full">
                <IonLabel>
                  <strong>Add Crew</strong>
                </IonLabel>
                <IonBadge slot="end" color="medium">
                  {crews?.length || 0}
                </IonBadge>
              </IonItem>
              <div slot="content">
                {crewsLoading ? (
                  <IonItem lines="none">
                    <IonLabel color="medium">
                      Loading crews...
                    </IonLabel>
                  </IonItem>
                ) : !crews || crews.length === 0 ? (
                  <IonItem lines="none">
                    <IonLabel color="medium">
                      No crews yet.
                    </IonLabel>
                  </IonItem>
                ) : (
                  <IonList>
                    {crews.map((crew: any) => (
                      <IonItem key={crew.id} button={true} detail={false} onClick={() => applyCrewToSelection(crew)}>
                        <IonAvatar slot="start">
                          {crew.avatarUrl ? (
                            <img src={crew.avatarUrl} alt={crew.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                          ) : (
                            <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 800, fontSize: "14px", background: "#e5e5e5", color: "#333" }}>
                              {getInitials(crew.name)}
                            </div>
                          )}
                        </IonAvatar>
                        <IonLabel className="ion-text-wrap">
                          <strong>{crew.name}</strong>
                          <div style={{ marginTop: "2px" }}>
                            <IonText color="medium">
                              {crew.description && crew.description.trim().length > 0 ? crew.description : "No description"}
                            </IonText>
                          </div>
                        </IonLabel>
                        <IonBadge slot="end" color="medium">
                          {crew.memberCount}
                        </IonBadge>
                      </IonItem>
                    ))}
                  </IonList>
                )}
              </div>
            </IonAccordion>
          </IonAccordionGroup>
          <IonGrid>
            <IonItem button={true} detail={false} onClick={handleSelectAllClick}>
              <IonLabel>
                {searchText?.trim() ? "Select All (filtered)" : "Select All"}
                <IonText color="medium">
                  <div style={{ marginTop: "2px", fontSize: "13px" }}>
                    {visibleSelectedCount} selected / {visibleUidsCount} associates
                  </div>
                </IonText>
              </IonLabel>
              <IonCheckbox slot="end" checked={allFilteredSelected} indeterminate={someFilteredSelected} disabled={true} />
            </IonItem>
            <IonList className="searchBar">
              {filteredSorted.map((val) => (
                <IonItem key={val.WerkerUid} className="searchBar">
                  <IonAvatar slot="start">
                    <img src={val.WerkerProfilePicURL} alt="" />
                  </IonAvatar>
                  <IonLabel>
                    <h2>{val.WerkerFirstName} {val.WerkerLastName}</h2>
                    <p>{val.WerkerCompany}</p>
                  </IonLabel>
                  <IonCheckbox slot="end" checked={val.isInvited} onIonChange={(e) => handleCrewList(val.WerkerUid, e)} />
                </IonItem>
              ))}
            </IonList>
          </IonGrid>
        </IonContent>
      </div>
    );
  }

  return (
    <IonPage>
      <WerkerSchedulerHeader title={HEADERTEXT_TYPES.ChooseWerkers} />
      <IonContent
        ref={contentRef}
        scrollEvents={true}
        onIonScroll={onContentScroll}
      >
        <IonSearchbar
          placeholder="Filter by #Tag, name, company, etc..."
          value={searchText}
          onIonChange={(e: any) => setSearchText(e.detail.value!)}
        />
        {/* Crews Quick Add */}
        <IonAccordionGroup
          value={crewAccordionValue}
          onIonChange={(e) => setCrewAccordionValue((e.detail.value as string) || undefined)}
        >
          <IonAccordion
            value="crews"
          >
            <IonItem
              slot="header"
              lines="full"
            >
              <IonLabel>
                <strong>Add Crew</strong>
              </IonLabel>

              <IonBadge
                slot="end"
                color="medium"
              >
                {crews?.length || 0}
              </IonBadge>
            </IonItem>

            <div slot="content">
              {crewsLoading ? (
                <IonItem
                  lines="none"
                >
                  <IonLabel
                    color="medium"
                  >
                    Loading crews...
                  </IonLabel>
                </IonItem>
              ) : !crews || crews.length === 0 ? (
                <IonItem
                  lines="none"
                >
                  <IonLabel
                    color="medium"
                  >
                    No crews yet.
                  </IonLabel>
                </IonItem>
              ) : (
                <IonList>
                  {crews.map((crew: any) => (
                    <IonItem
                      key={crew.id}
                      button={true}
                      detail={false}
                      onClick={() => applyCrewToSelection(crew)}
                    >
                      <IonAvatar
                        slot="start"
                      >
                        {crew.avatarUrl ? (
                          <img
                            src={crew.avatarUrl}
                            alt={crew.name}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                        ) : (
                          <div
                            style={{
                              width: "100%",
                              height: "100%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontWeight: 800,
                              fontSize: "14px",
                              background: "#e5e5e5",
                              color: "#333",
                            }}
                          >
                            {getInitials(crew.name)}
                          </div>
                        )}
                      </IonAvatar>

                      <IonLabel
                        className="ion-text-wrap"
                      >
                        <strong>{crew.name}</strong>

                        <div style={{ marginTop: "2px" }}>
                          <IonText
                            color="medium"
                          >
                            {crew.description && crew.description.trim().length > 0
                              ? crew.description
                              : "No description"}
                          </IonText>
                        </div>
                      </IonLabel>

                      <IonBadge
                        slot="end"
                        color="medium"
                      >
                        {crew.memberCount}
                      </IonBadge>
                    </IonItem>
                  ))}
                </IonList>
              )}
            </div>
          </IonAccordion>
        </IonAccordionGroup>

        <IonGrid>
          <IonItem
            button={true}
            detail={false}
            onClick={handleSelectAllClick}
          >
            <IonLabel>
              {searchText?.trim() ? "Select All (filtered)" : "Select All"}

              <IonText
                color="medium"
              >
                <div style={{ marginTop: "2px", fontSize: "13px" }}>
                  {visibleSelectedCount} selected / {visibleUidsCount} associates
                </div>
              </IonText>
            </IonLabel>

            {/* display-only checkbox (prevents “programmatic onIonChange wipe” bug) */}
            <IonCheckbox
              slot="end"
              checked={allFilteredSelected}
              indeterminate={someFilteredSelected}
              disabled={true}
            />
          </IonItem>

          <IonList
            className="searchBar"
          >
            {filteredSorted.map((val) => (
              <IonItem
                key={val.WerkerUid}
                className="searchBar"
              >
                <IonAvatar
                  slot="start"
                >
                  <img src={val.WerkerProfilePicURL} alt="" />
                </IonAvatar>
                <IonLabel>
                  <h2>
                    {val.WerkerFirstName} {val.WerkerLastName}
                  </h2>
                  <p>{val.WerkerCompany}</p>
                </IonLabel>
                <IonCheckbox
                  slot="end"
                  checked={val.isInvited}
                  onIonChange={(e) => handleCrewList(val.WerkerUid, e)}
                />
              </IonItem>
            ))}
          </IonList>
        </IonGrid>
      </IonContent>
      <IonFooter>
        <IonToolbar>
          <IonButton
            expand="block"
            color="seconwarning"
            onClick={handleSubmit}
          >
            Submit
          </IonButton>
          <IonButton
            expand="block"
            fill="clear"
            color="medium"
            onClick={() => {
              if (desktopMode?.onComplete) {
                desktopMode.onComplete({ nextView: "details", jobId: routeJobId });
              } else {
                history.replace(`/SchedShiftDetail/${routeJobId}`);
              }
            }}
          >
            Invite Later
          </IonButton>
          <br />
        </IonToolbar>
      </IonFooter>
    </IonPage>
  );
};

export default SelectWerkers;
